import type { FaireProductEntity } from "../../entity_types/product";

export const p_trpp5ad4tc: FaireProductEntity = {
  token: "p_trpp5ad4tc",
  type: "product",
  name: "Soft Touch Open Front Knit Cardigan",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/6d8580af6ddb820eb62257804f1fa9169f329dccd4ed9e7bff59c2d6a729e67e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/20e4ef836f19cfff55f6c10bb190c57f271c6bbe109092afac3ada9e1b9c5fac.jpeg",
    "https://cdn.faire.com/fastly/e6aee1a85caf7aeeee093b88dc7786036254f110c8a8803ad777063d5a0a9fd8.jpeg",
    "https://cdn.faire.com/fastly/72e45d8426fd40dc58b0814567feae5bc6a087df9f31d07ae28550431e9806a2.jpeg",
    "https://cdn.faire.com/fastly/cba2f1356440ff32b4bb6740477c99215c6f93c3a363aff28bd787ef3b3ace5c.jpeg",
    "https://cdn.faire.com/fastly/2655aeabdd07364887a7e247995ea5f9b6af53e8c13e664ce84adb0bb420db79.jpeg",
    "https://cdn.faire.com/fastly/72c61500613bf774f28d73c50fc93e1587bb078628f82906216a636e0b59914b.jpeg",
    "https://cdn.faire.com/fastly/a6f00169872ba74cbe975c1661f63760e4cd979ace90bc013359e8cdcc33cb12.jpeg",
    "https://cdn.faire.com/fastly/6a8af28bdc88895087c34fc7d8bec7ac8a24c8ff305b5282001374719ba09b48.jpeg",
    "https://cdn.faire.com/fastly/61ce483c904fa616edaaef0a3ff8a7afecdad6a61fbb23de45f1c81a3bf5f2c7.jpeg",
    "https://cdn.faire.com/fastly/b569fc7017ecc12daff2c6eaac1bf29e6a53697411b620b477cbd5e05e6fbd78.jpeg",
    "https://cdn.faire.com/fastly/97d4bd5607126208605c25f7440670f28be9822fc434416304dd5785c25d9028.jpeg",
    "https://cdn.faire.com/fastly/2d7e1a2bc36ca31d2c07165ff0d6ebdebfd068cb4bd33273c66e096d6f29568f.jpeg",
    "https://cdn.faire.com/fastly/da16f110cfbc798ca687ac4e9b629cd8ec1c85617a473430c5f3aa49b0c31b50.jpeg",
    "https://cdn.faire.com/fastly/285015e590b988938ee3682ad326dfa029d0b7f93e5da6d4bf15203d7aebdf6e.jpeg",
    "https://cdn.faire.com/fastly/d1839af640bfb0138af033b8bedd228bfa52288de3ddad8d59eeff2488d5edd5.jpeg",
    "https://cdn.faire.com/fastly/4156e8c7e03d408e90e06723dc9d32cb1005d7f0ab370fb32b87a009e2e08e07.jpeg",
    "https://cdn.faire.com/fastly/30865f3e0292a02517f5162e673f54555e0a981a744493711e0d3c148918c56e.jpeg",
    "https://cdn.faire.com/fastly/9549273663296fa922a17e382b47c201780b3d15b8f4cf2fca057c891786078a.jpeg",
    "https://cdn.faire.com/fastly/864d49541f23da53eb5c4f63839d55073c9bea0bb6bd2433f95de929c0f9c3da.png",
  ],
  priceDollars: 29.9,
  description:
    "ELEVATE YOUR COMFORT STYLE WITH THIS PLUSH OPEN FRONT CARDIGAN, FEATURING A FEATHER-LIGHT KNIT AND DRAPING SILHOUETTE FOR EFFORTLESS EVERYDAY ELEGANCE.\n\nIMPORTED, DESIGNED IN USA\n\nFEATHER-LIGHT PLUSH KNIT FABRIC\n\nOPEN FRONT DESIGN AND RELAXED DRAPING FIT\n\nCONT 100% ACRYLIC\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 62.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:16.552Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
